
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sections/components/StageSideAreaBorder/StageSideAreaBorder.scss.css.virtualfile';
        module.exports = {"border":"_border_9cc9d_7","mobileEditor":"_mobileEditor_9cc9d_14","left":"_left_9cc9d_14"};